import { render, staticRenderFns } from "./pressReleasesDetail.vue?vue&type=template&id=05fc34fc&scoped=true"
import script from "./pressReleasesDetail.vue?vue&type=script&lang=js"
export * from "./pressReleasesDetail.vue?vue&type=script&lang=js"
import style0 from "./pressReleasesDetail.vue?vue&type=style&index=0&id=05fc34fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc34fc",
  null
  
)

export default component.exports